var $ = jQuery.noConflict();

$(window).on('load', function () {
    let method = 'front';
    if ($('body').hasClass('wp-admin'))
        method = 'wp-admin';

    var initializeBlock = function ($block) {

        function checkPosts() {
            if($('.block-posts-list .end').length > 0)
                $('.block-posts-list__load').remove();
        }
        checkPosts();

        $(document).on('click', '.block-posts-list__load', function (event) {
            $(this).addClass('load');

            let paged = $('.block-posts-list').attr('data-paged');
            paged++;
            $('.block-posts-list').attr('data-paged', paged);

            let search = $('.block-posts-list').data('search');
            let category = $('.block-posts-list').data('category');
            let type = $('.block-posts-list').data('type');
            let lang = $('.block-posts-list').data('lang');

            jQuery.ajax({
                type: "GET",
                url: phpvars.ajax_url,
                data: 'action=posts_display&page=' + paged + '&category=' + category + '&type=' + type  + '&search=' + search + '&lang=' + lang,
                success: function (data) {
                    $('.block-posts-list__results > .row').eq(0).append(data);

                    $('.block-posts-list__load').removeClass('load');

                    checkPosts();
                },
                error: function (errorThrown) {
                }
            });
        })


    };

    window.onload = function () {
        initializeBlock($(this));
    }();

    if (window.acf) {
        window.acf.addAction('render_block_preview/type=posts-list', initializeBlock);
    }
})

